// Public discovery is paused by the founder. Preserve existing customer,
// payment-result and fulfilment links; this never changes order or ledger data.
export const retiredMarketplaceHosts = ['getyofo.com', 'www.getyofo.com', 'marketplace.plateos.io'];
export function isRetiredPublicSurface(hostname, pathname) {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  // /claim is also PlateOS Launch Engine's token-based takeover flow.
  if (/^\/marketplace(?:\/|$)/.test(pathname)) return true;
  if (!retiredMarketplaceHosts.includes(host)) return false;
  const existingService = /^\/(?:api|customers|customer|driver|track|t|agreement|support|shopify-sso|payment-success|payment-cancelled)(?:\/|$)/;
  return !existingService.test(pathname) && !/^\/catering\/quote(?:\/|$)/.test(pathname);
}
